import React, { FC } from 'react'
import nomAgencyYearBadge from '../../images/2025-nom-agency-year-v2.svg'

const NomAgencyYearBadge: FC = () => {
  return (
    <div>
      <img
        src={nomAgencyYearBadge}
        alt="Nominated agency of the year"
        className="nom-agency-year-badge"
      />
    </div>
  )
}

export default NomAgencyYearBadge
